
/* injects from baggage-loader */

/** Section Api */

const moduleSection = angular.module('api.section', []);

moduleSection.factory('Section', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope",
  ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) => {

    class SectionApi {

      createPublic(params) {
        return Restangular.all('sections').post(params);
      }
      savePublic(section) {
        const id = section.id + '';

        return Restangular.all('sections').one(id).customPUT(section);
      }

      saveTemplate(section) {
        const id = section.id + '';

        return Restangular.all('sections').one(id).all('create_template').post(section);
      }

      createItem(section, params, isPublic) {
        if (isPublic == null) {
          isPublic = false;
        }

        const id = section.id + "";

        if (isPublic) {
          return Restangular.all("sections").one(id).customPUT(params);
        } else {
          return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT(params);
        }
      }
      destoyItem(section, imageId) {
        const id = section.id;

        return Restangular.all("sections").one(id).all("images").one(imageId).customDELETE();
      }
      create(id, type) {
        const {siteId, pageId} = $state.params;
        const requestParams = {
          section_id: id,
          section_type: type,
        }

        if (type !== 'default' && !!window.justclick.userSiteId) {
          requestParams['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular
            .all('sites').one(siteId)
            .all('pages').one(pageId)
            .all('sections').post(requestParams);
      }
      clone(id, type) {
        const {siteId, pageId} = $state.params;
        const requestParams = {
          section_id: id,
          section_type: type,
        };

        if (type !== 'default' && !!window.justclick.userSiteId) {
          requestParams['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular
            .all('sites').one(siteId)
            .all('pages').one(pageId)
            .all('sections/clone').post(requestParams);
      }
      save(layout) {
        const section = layout.section;

        this.beforeSave(layout);

        section.structure = this.generateJSON(layout.one(ns.wrapperClass));

        const id = layout.section.id + "";
        const isPublic = section.is_template;

        if (isPublic) {
          return this.savePublic(section);
        } else {
          const {siteId, pageId} = $state.params;

          return Restangular
              .all('sites').one(siteId)
              .all('pages').one(pageId)
              .all('sections').one(id).customPUT(section);
        }
      }
      saveAllSectionsAndPublish(sections) {
        const {siteId, pageId} = $state.params;
        const {userSiteId} = window.justclick;
        const {currentSite} = $rootScope;
        const query = [];
        const putParameters = {
          sections: sections
        };

        if (Editor.option) {
          query.push('mixer=true');
        }

        if (userSiteId) {
          query.push(`global_site_id=${userSiteId}`);

          putParameters.site = {
            header_enabled: !!currentSite.header_enabled,
            footer_enabled: !!currentSite.footer_enabled
          };
        }

        let getParams = '';
        if (query.length > 0) {
          getParams = `?${query.join('&')}`;
        }

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("batch_update" + getParams).customPUT(putParameters);
      }
      getBuildStatus() {
        const {siteId} = $state.params;

        return Restangular.all("sites").one(siteId).one("build_status").get();
      }
      saveAllSectionsAndPublishPreview(sections) {
        const {siteId, pageId} = $state.params;

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("save_preview").customPUT({
          sections: sections
        });
      }
      saveSettings(section) {
        section = angular.copy(section);

        delete section.structure;
        delete section.background_attributes.images_attributes;

        if (section.is_template) {
          return this.savePublic(section);
        } else {
          const {siteId, pageId} = $state.params;
          const id = section.id + "";

          return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
        }
      }
      update(section) {
        const {siteId, pageId} = $state.params;
        const id = section.id + "";

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
      }
      update_for_mixer(section) {
        const {siteId, pageId} = $state.params;
        const id = section.id + "";

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).all("update_for_mixer").customPUT(section);
      }
      remove(id) {
        const {siteId, pageId} = $state.params;

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT({
          removed: true
        });
      }
      removePublic(id) {
        return Restangular.all("sections").one(id).customDELETE();
      }
      restore(id) {
        const {siteId, pageId} = $state.params;

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT({
          removed: false
        });
      }
      removeBg(section) {
        const id = section.id + "";

        section = angular.copy(section);
        section.remove_background = true;

        if (section.is_template) {
          return Restangular.all("sections").one(id).customPUT(section);
        } else {
          const {siteId, pageId} = $state.params;

          return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").one(id).customPUT(section);
        }
      }
      sort(sectionsIds) {
        const {siteId, pageId} = $state.params;

        return Restangular.all("sites").one(siteId).all("pages").one(pageId).all("sections").all("sort").post({
          sections: sectionsIds
        });
      }
      get(id) {
        return Restangular.all("sites").one(id).get();
      }
      getHTML(section) {
        const {siteId, pageId} = $state.params;
        const requestData = {};

        if (section.section_type !== 'default' && !!window.justclick.userSiteId) {
          requestData['global_site_id'] = window.justclick.userSiteId;
        }

        return Restangular
            .all("sites").one(siteId)
            .all("pages").one(pageId)
            .all("sections").customGET(section.id + ".html", requestData);
      }
      getPublicSectionHTML(id) {
        return Restangular.all("sections").one(id + ".html").get();
      }
      getPublicSectionStylesheet() {
        const id = $state.params.sectionId;

        return Restangular.all("sections").one(id + ".css").get();
      }
      getCollection(category, colors) {
        return Restangular.one("sections").get({
          tag: category,
          "color[]": colors
        });
      }
      getCategories(site_id) {
        return Restangular.all("sections").all("tags").getList({
          site_id: site_id
        });
      }
      getSections(for_email) {
        if (for_email == null) {
          for_email = false;
        }
        if (for_email) {
          return Restangular.all("sections").one("all?for_email=true").get();
        } else {
          return Restangular.all("sections").one("all").get();
        }
      }
      getLessonSections() {
        return Restangular.all("sections").one("all?for_lms_page=true").get();
      }
      beforeSave(layout) {
        return this.setTextContents(layout);
      }
      setTextContents(layout) {
        const Y = $rootScope.Y;

        layout.all(
          [ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')
        ).each((block) => {

          const jBlock = $(block.one(ns.widgetWrapperClass)._node);

          if (jBlock.find("#cke_pastebin").length > 0) {
            jBlock.find("#cke_pastebin").attr("style", "");
            jBlock.find("#cke_pastebin").replaceWith($('<span>' + jBlock.find("#cke_pastebin").html() + '</span>'));
          }

          const content = jBlock.html();

          if (!block.widget) {
            block.widget = {content: ""};
          } else {
            if (($rootScope.widgetsIsMixer != null) && ($rootScope.widgetsIsMixer[block.widget.id] != null)) {
              block.widget.in_mixer_active = $rootScope.widgetsIsMixer[block.widget.id];
            }
            block.widget.content = content;
          }

          // Very strange behaviour, sometimes the widget has property with empty name, and it produces an error while saving a page
          Object.keys(block.widget).forEach((k) => k === '' && delete block.widget[k]);
        });
      }

      generateJSON(block) {
        const blocksBuilder = $injector.get("blocksBuilder");
        const result = {};

        if (!block) {
          err("Can't recognize block");
        }

        if (block.hasClass(ns.rowClass.substr(1))) {
          result.cols = [];
          block.get("children").filter(ns.colClass).each((block) => {
            result.cols.push(this.generateJSON(block));
          });
        } else if (block.hasClass(ns.colClass.substr(1)) || block.hasClass(ns.wrapperClass.substr(1))) {

          if (block.test("[class*='str-col-']")) {
            result.size = blocksBuilder.getColSize(block);
          }

          let widgets = [];
          let rows = [];

          block.get("children").each(((block) => {
            if (block.test(ns.rowClass)) {
              if (0 !== widgets.length) {
                rows.push({
                  cols: [{
                    size: result.size,
                    widgets: $rootScope.Y.clone(widgets, true)
                  }]
                });
                widgets = [];
              }

              rows.push(this.generateJSON(block));
            } else if (block.test(ns.blockClass)) {
              block = block.widget;
              if (!block) {
                err("Block has not json");
              }
              widgets.push(block);
            }
          }));

          if (0 === rows.length) {
            result.widgets = widgets;
          } else {
            if (0 !== widgets.length && !result.size) {
              err("Col size is invalid: ", result.size);
            }
            if (result.size && widgets.length) {
              rows.push({
                cols: [{
                  size: result.size,
                  widgets: $rootScope.Y.clone(widgets, true)
                }]
              });
            }
            result.rows = rows;
          }
        }

        if (result.rows && 0 === result.rows.length || result.cols && 0 === result.cols.length) {
          delete result.rows;
          delete result.cols;
          result.widgets = [];
          block.get("children").filter(ns.blockClass).each((block) => {
            result.widgets.push(block.widget);
          });
        }

        return result;
      }
    }

    return new SectionApi();
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/api/section.js